import Vue from 'vue'
let Eve = new Vue();
export default Eve;



// WEBPACK FOOTER //
// ./src/components/common/emit.js